<app-lms-modal-frame [title]="reportTitle" [pageHeadWidth]="600">
  <div modal-body class=" p-0">
    <div class="container-fluid">
    <section class="loans-section">

      <div class="table-panel">
        <div class="table-scroll-wrapper">
          <lms-table-wrapper [config]="config">
            <table class="table table-sm table-striped table-auto table-bordered shadow-2-strong rounded-1 loans-table" #TABLE>
              <caption>
                {{ reportTitle }}
                <span *ngIf="startDate && endDate"> &mdash; {{ startDate }} to {{ endDate }}</span>
              </caption>
              <thead class="sticky-thead">
                <tr>
                  <th scope="col">Loan Number</th>
                  <th scope="col">ID Number</th>
                  <th scope="col">First Name</th>
                  <th scope="col">Last Name</th>
                  <th scope="col">Created On</th>
                  <th scope="col">Completed On</th>
                  <th scope="col">Process Type</th>
                  <th scope="col">Status</th>
                  <th scope="col">Reject Reason</th>
                  <th scope="col">Reject Other Reason</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of fieldLoansReportList | paginate: config">
                  <td>{{ row.id }}</td>
                  <td>{{ row.idNumber }}</td>
                  <td>{{ row.firstName }}</td>
                  <td>{{ row.lastName }}</td>
                  <td>{{ row.createdOn | date: 'yyyy-MM-dd' }}</td>
                  <td>{{ row.completedOn | date: 'yyyy-MM-dd' }}</td>
                  <td>{{ row.processType }}</td>
                  <td>{{ row.status }}</td>
                  <td>{{ row.rejectReason }}</td>
                  <td>{{ row.rejectOtherReason }}</td>
                </tr>
                <tr *ngIf="fieldLoansReportList.length === 0">
                  <td colspan="12" class="text-center text-muted py-3">No data available.</td>
                </tr>
              </tbody>
            </table>
          </lms-table-wrapper>
        </div>
      </div>

      <div class="action-bar">
        <button class="btn-action btn-export" type="button" (click)="exportToExcel()">
          <i class="fas fa-file-excel fa-fw"></i> Export to Excel
        </button>
        <button class="btn-action btn-close-modal" type="button" (click)="close()">Close</button>
      </div>

    </section>
    </div>
  </div>
</app-lms-modal-frame>
